var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32d157",
    d: "M10,19.5c5.25,0,9.5-4.25,9.5-9.5c0-5.25-4.25-9.5-9.5-9.5S0.5,4.75,0.5,10C0.5,15.25,4.75,19.5,10,19.5z  M5.45,9.61c0.29-0.29,0.77-0.29,1.06,0l2.34,2.34l4.36-5.51c0.26-0.32,0.73-0.38,1.05-0.12c0.32,0.26,0.38,0.73,0.12,1.05 L9.5,13.55c-0.13,0.17-0.33,0.27-0.54,0.28c-0.01,0-0.03,0-0.04,0c-0.2,0-0.39-0.08-0.53-0.22l-2.94-2.94 C5.15,10.38,5.15,9.91,5.45,9.61z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.c643ef596f87c1ee436684c6aee2f326.svg";
export { ForwardRef as ReactComponent };